module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.when_might_show')))]), _vm._v(" "), _c('div', {
    staticClass: "box-description"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_when_box_should_apper')))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-ab5648fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/viewmode/Header.vue
 ** module id = 900
 ** module chunks = 1
 **/